import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Case_Arrow } from "../../../app-constants";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Singleproject(props) {
  const gradientStyle = {
    background: "linear-gradient(90deg, #f9f4ea 70%, rgb(255, 255, 255) 70%)",
  };
  const ColorStyle = {
    color: "#000",
  };
  const textAndBackgroundColor = {
    backgroundColor: "#000",
  };
  return (
    <div className="singleproject p-100" style={gradientStyle}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="img_logo">
              <StaticImage
                src="../../images/location_new/singlecase/md-logo.png"
                alt="LogoNext"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={270}
                height={68}
              />
            </div>
            <div className="example" data-text="Feature">
              <h2 style={ColorStyle}>
                Mdrouz: A Multi-Vendor E-commerce Mobile Application
              </h2>
            </div>
            <p style={ColorStyle}>
              Mdrouz is a cutting-edge multi-vendor e-commerce mobile
              application developed by TekRevol for the GCC region, specifically
              targeting consumers interested in purchasing clothing articles
              such as burqas and abayas.
            </p>
            <Link
              to={`/case-studies/mdrouz`}
              className="case_btn"
              aria-label="TekRevol Contact"
              style={textAndBackgroundColor}
            >
              View Case Study {Case_Arrow}
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="technology_list">
              <div className="tech_name">iOS App</div>
              <div className="tech_name">Android App</div>
              <div className="tech_name">UI UX Design</div>
            </div>
            <div className="mx-img">
              <StaticImage
                src="../../images/location_new/singlecase/mdrouz.webp"
                alt="Mdrouz profile image"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={909}
                height={600}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Singleproject;
